<template>
   <div ref="logoContainer" class="logo-animation">
      <div v-for="(images, index) in this.imageNum" class="logo" :key="index">
         <img :src="newImages[currentImages[index]]" :class="'logo-' + (index + 1)">
      </div>
   </div>
</template>

<script>

    export default {
        name: 'LogoAnimation',
        data() {
            return {
                imageNum: 3,
                images: [
                    'nat-geo.svg',
                    'nbc-universal.svg',
                    'wired.svg',
                    'edelman.svg',
                    'conde-nast.svg',
                    'spotify.svg',
                    'dow-jones.svg',
                    'revolt.svg',
                    'usa-today.svg'
                ],
                currentImages: [ 0, 1, 2 ],
                logoLoop: null
            }
        },
        computed: {
            newImages() {
                let images = this.images.map((x) => {
                    return require('./../assets/images/logos/' + x)
                })

                return images
            }
        },
        methods: {
            startLoop() {

                this.logoLoop = setInterval(() => {

                    this.$el.classList.remove('enter'); // fade out the logos.
                    this.$el.classList.add('leave'); // not using .replace here due to issues in IE

                    setTimeout(() => {

                      if (this.currentImages.includes(8)) {

                        for (var i = 0; i < this.currentImages.length; i++) {
                          this.currentImages.splice(i, 1, i)
                        }

                      } else {

                        for (var i = 0; i < this.currentImages.length; i++) {
                          this.currentImages.splice(i, 1, this.currentImages[i] + 3)
                        }

                      }

                      this.$el.classList.remove('leave')

                      setTimeout(() => {
                        this.$el.classList.add('enter')
                      }, 20) // just a tiny delay so that it can transform back to its original state

                    }, 800) // time to wait until leave transition is over to switch images

                }, 3500); // How often to run logo switching animation
            },
            stopLoop () {
                clearInterval(this.logoLoop);
            }
        },
        mounted() {

            setTimeout(() => {
                this.$refs.logoContainer.classList.add('enter') // initial fade-in of logos
                this.startLoop();
            }, 600);

            this.$store.watch(
                (state) => {
                    return state.view;
                },
                (state) => {
                    if (state === 'intro') {
                        this.startLoop();
                    } else {
                        this.stopLoop();
                    }
                }
            );
        },
        beforeDestroy () {
            clearInterval(this.logoLoop);
        }
    }
</script>

<style lang="scss">
   @import "./../scss/the-goods";

   $logoNum: 3;

   $enterTime: 1000ms;
   $leaveOpacityTime: 500ms;
   $leaveTransformTime: 700ms;

   $enterDelayNum: 200ms;
   $leaveDelayNum: 150ms;

   $enterDelayTotal: $enterDelayNum * $logoNum; // 600
   $leaveDelayTotal: $leaveDelayNum * $logoNum; // 450

   $enterTotal: $enterTime + $enterDelayTotal; // 1600
   $leaveTotal: $leaveTransformTime + $leaveDelayTotal; //  1150

   $totalAnimationTime: $enterTotal + $leaveTotal; // 2750

   .logo-animation {
      transform-origin : left;
      display          : flex;

      .logo {
         flex     : 1;
         height   : 50px;

         img {
            width      : 70%;
            height     : 100%;
            opacity    : 0;
            transform  : translateY(12px); // state where animation starts
            transition : none;

            @include screen-xxl {
               width : 80%;
            }
         }
      }

      &.enter {
        .logo {
          img {
            opacity : 1;
            transition : opacity $enterTime, transform $default-bez $enterTime; // animations for logos on enter
            transform : translateY(0px); // state that each logo animates to from enter, and away from on leave
          }

          @for $i from 2 through 3 {
             img.logo-#{$i} {
               transition-delay: ($i - 1) * $enterDelayNum; // delay for each individual logo on enter
             }
          }
        }
      }

      &.leave {
        .logo {
          img {
            opacity : 0;
            transform : translateY(-8px);
            transition : opacity $leaveOpacityTime, transform $default-bez $leaveTransformTime; // animations on logos on leave
          }

          @for $i from 2 through 3 {
             img.logo-#{$i} {
               transition-delay: ($i - 1) * $leaveDelayNum; // delay for each individual logo on leave
             }
          }
        }
      }
   }

</style>



// WEBPACK FOOTER //
// src/components/LogoAnimation.vue